// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3Y0Ua","addWidgetButton":"Header_addWidgetButton__1MlpC","dashboardTabs":"Header_dashboardTabs__1ykni","active":"Header_active__3OSS-"};